module.exports = __webpack_public_path__ + "school/img/zhengshuYc.8a40614d.jpg";